import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-error/10 via-background to-error/5 px-4">
      <div className="w-full max-w-md text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-error/10 mb-6">
          <Icon name="ShieldX" className="w-10 h-10 text-error" />
        </div>
        <h1 className="text-4xl font-bold text-foreground mb-4">Access Denied</h1>
        <p className="text-foreground-secondary mb-8">
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={() => navigate(-1)} variant="outline">
            <Icon name="ArrowLeft" className="w-5 h-5 mr-2" />
            Go Back
          </Button>
          <Button onClick={() => navigate('/client-dashboard')}>
            <Icon name="Home" className="w-5 h-5 mr-2" />
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;